import { Pipe, PipeTransform } from '@angular/core'
import { invalidPipeArgumentError } from './invalid-pipe-argument-error'

@Pipe({ name: 'date' })
export class DatePipe implements PipeTransform {
  transform(value: any, options: {}): string {
    if (value == null) {
      return 'n/a'
    }

    let date
    if (value instanceof Date) {
      date = value
    } else {
      date = Date.create(value)
    }

    const pattern = Object.get(options, 'pattern') || '{Mon} {d}, {year}'
    try {
      return date.format(pattern)
    } catch(e) {
      throw invalidPipeArgumentError('date', value)
    }
  }
}
